export const MESSAGE_TYPES = {
    CHAT: 'chat',
    DRAFT: 'draft',
};

export const FILE_SIZE = 21000000;